module.exports = __webpack_public_path__ + "static/media/instagram-svgrepo-com (1).3a6347dc.svg";